<script >
import { computed } from 'vue-demi';
const __sfc_main = {};
__sfc_main.props = {
  theme: [String, Boolean],
  activeColor: {
    type: String,
    default: '#FF6900'
  },
  isActive: Boolean
};
__sfc_main.setup = (__props, __ctx) => {
  const props = __props;
  const lineColor = computed(() => {
    return props.theme === 'dark' ? '#E3E4E5' : '#0F1112';
  });
  return {
    lineColor
  };
};
export default __sfc_main;
</script>
<template>
    <svg
        v-if="isActive"
        class="heading-icon"
        width="26"
        height="2"
        viewBox="0 0 26 2"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <line y1="1" x2="26" y2="1" :stroke="activeColor" stroke-width="2" />
    </svg>
    <svg
        v-else
        class="heading-icon"
        width="26"
        height="26"
        viewBox="0 0 26 26"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <line y1="13" x2="26" y2="13" :stroke="lineColor" stroke-width="2" />
        <line x1="13" y1="26" x2="13" y2="4.37114e-08" :stroke="lineColor" stroke-width="2" />
    </svg>
</template>
